import React from "react";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";

function Results() {
    return (
        <div className="bg-white-dark pt-20 px-28 pb-32 rounded-16 flex flex-col justify-center">
            <div className=" border-2 border-[#212121] border-dashed text-center text-[1.4rem] pt-12 pb-[30rem]">
                <span>پیش نمایش فایل نتیجه</span>
            </div>
            <BtnPrimary
                text="دانلود نتیجه"
                className=" px-52 py-11 self-center mt-10"
            />
        </div>
    );
}

export default Results;
